module.exports = __webpack_public_path__ + "img/data.ae0f47cb.png";